exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-input[data-v-b302c582] {\n  padding: 0.375rem 0.75rem;\n  color: #3e515b;\n  border: 1px solid #d1d4d7;\n  max-height: 200px;\n  overflow-y: auto;\n}\n.canvas-wrapper[data-v-b302c582] {\n  max-width: 200px;\n  padding: 5px;\n  overflow: auto;\n}\n[data-v-b302c582]::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px;\n  height: 6px;\n}\n[data-v-b302c582]::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: #b7b8b9;\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b302c582","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/utils/contentEditable.vue
// module id = 1165
// module chunks = 2